import { getSearch, requestCreate, requestDelete, requestSubmit, requestUpdate } from "../api";
import {
    ADD_IN_LIST,
    RESET_FORM,
    RESET_STATE,
    SET_FORM,
    SET_LIST
} from "../constant-types";
import { getField, updateField } from "vuex-map-fields";
import {defaultAddInListMutation, defaultRemoveInListMutation, defaultSetListMutation, defaultSetLoading, defaultUpdateInListMutation} from "../default-method";

const getDefaultState = () => {
    return {
        list: null,
        search_params: getDefaultSearchParamsState(),
        form: getDefaultFormState()
    };
};

const getDefaultFormState = () => {
    return {
        id: "",
        category_id: "",
        description: "",
        qty: 1,
        unit_id: "",
        nominal: 0,
        from_user_cash_id: "",
        memo: ""
    };
};

const getDefaultSearchParamsState = () => {
    return {
        filter_search_text: "",
        loading: false,
        filter_sort: [
            {
                column: "created_at",
                sort: "desc",
                icon: ["fas", "angle-down"]
            }
        ],
        filter_page: 1,
        filter_limit: 10
    };
};
export default {
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState());
        },
        [RESET_FORM](state) {
            state.form = getDefaultFormState();
        },
        ...defaultAddInListMutation,
        ...defaultSetListMutation,
        ...defaultRemoveInListMutation,
        ...defaultUpdateInListMutation,
        ...defaultSetLoading,
        [SET_FORM](state, payload) {
            state.form = JSON.parse(JSON.stringify(payload))
        },
        updateField
    },
    // can async
    actions: {
        loadList(
            { commit, state, getters },
            payload = {
                resetPage: false
            }
        ) {
            if (payload.resetPage) {
                commit("updateField", {
                    path: "search_params.filter_page",
                    value: 1
                });
            }
            return getSearch(
                {
                    words: _.split(state.search_params.filter_search_text, " "),
                    fields: ["category>name", "description", "unit>name", "fromUserCash>name"]
                },
                [],
                [],
                state.search_params.filter_sort,
                state.search_params.filter_page,
                state.search_params.filter_limit,
                ["category", "unit", "fromUserCash"],
                [],
                "cost",
                response => commit(SET_LIST, response),
                () => {},
                () => {}
            );
        },
        requestCreateCost({ state, commit, dispatch }) {
            return requestCreate('cost', state.form, commit, 'ADD_IN_LIST', undefined, undefined, (successResponse) => {
                // should refresh userCash
                dispatch("userCash/loadList", null, { root: true });
            })
        },
        requestUpdateCost({ state, commit, dispatch }) {
            return requestUpdate(`cost/${state.form.id}`, state.form, commit, 'UPDATE_IN_LIST', undefined, undefined, (successResponse) => {
                // should refresh userCash
                dispatch("userCash/loadList", null, { root: true });
            })
        },
        requestDeleteCost({ state, commit, dispatch }, cost) {
            return requestDelete(`cost/${cost.id}`, {}, commit, cost.description, 'REMOVE_IN_LIST', undefined, undefined, (successResponse) => {
                // should refresh userCash
                dispatch("userCash/loadList", null, { root: true });
            })
        }
    },
    // call variable with custom display
    getters: {
        getField
    }
};
